module.exports = __webpack_public_path__ + "img/prize-00.2edffdde.png";